"use strict";var e=require("@apollo/client"),t=e.gql`
  query GetStore($storeId: ID, $clientId: String) {
    getStore(storeId: $storeId, clientId: $clientId) {
      dynamicParams
      id
      name
      code
      state
      cities {
        name
      }
    }
  }
`,o=e.gql`
  mutation CreateQuotation($createQuotationInput: CreateQuotationInput!) {
    createQuotation(createQuotationInput: $createQuotationInput) {
      clientId
      comment
      currency
      expiresAt
      id
      itemsQuantity
      number
      operationalModel
      purchasedAt
      status
    }
  }
`,r=e.gql`
  mutation DeleteMyAccount($accessToken: String!) {
    deleteMyAccount(accessToken: $accessToken) {
      success
    }
  }
`,s=e.gql`
  mutation DeleteMyAccountWithProxy(
    $authorizationCode: String!
    $redirectUrl: String!
  ) {
    deleteMyAccountWithProxy(
      authorizationCode: $authorizationCode
      redirectUrl: $redirectUrl
    ) {
      success
    }
  }
`,n=e.gql`
  fragment BaseCustomer on Customer {
    id
    name
    phoneNumber
    email
    terms
    notifications
    documentId
    uid
    customData
    addresses {
      address {
        structure
        other
      }
      addressTwo
      city
      description
      latitude
      longitude
      id
      coverage
      state
    }
  }
`,a=e.gql`
  ${n}
  mutation SignInWithProxy(
    $clientId: String!
    $authorizationCode: String!
    $redirectUrl: String!
  ) {
    signInWithProxy(
      clientId: $clientId
      authorizationCode: $authorizationCode
      redirectUrl: $redirectUrl
    ) {
      customer {
        ...BaseCustomer
      }
      token
    }
  }
`,i=e.gql`
  mutation Logout {
    logout
  }
`,d=e.gql`
  mutation restorePasswordConfirmWithProxy(
    $clientId: String!
    $restorePassDataConfirm: JSON!
  ) {
    restorePasswordConfirmWithProxy(
      clientId: $clientId
      restorePassDataConfirm: $restorePassDataConfirm
    ) {
      code
      message
    }
  }
`,u=e.gql`
  mutation restorePasswordWithProxy(
    $clientId: String!
    $restorePassData: JSON!
  ) {
    restorePasswordWithProxy(
      clientId: $clientId
      restorePassData: $restorePassData
    ) {
      name
      email
    }
  }
`,c=e.gql`
  mutation revokeOldTokensGenerateNewToken {
    revokeOldTokensGenerateNewToken
  }
`,m=e.gql`
  mutation Send2FA($send2FAInput: Send2FAInput!) {
    send2FA(send2FAInput: $send2FAInput) {
      success
      requestId
    }
  }
`,l=e.gql`
  mutation SignIn($clientId: String!, $accessToken: String!) {
    signIn(clientId: $clientId, accessToken: $accessToken) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        customData
        phoneNumberValidated
        shoppingCartVersion
        addresses {
          address {
            structure
            other
          }
          addressTwo
          city
          description
          latitude
          longitude
          id
          coverage
          state
        }
      }
      token
    }
  }
`,p=e.gql`
  mutation signInWithProxy($clientId: String!, $credentials: JSON!) {
    signInWithProxy(clientId: $clientId, credentials: $credentials) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        customData
        addresses {
          address {
            structure
            other
          }
          addressTwo
          city
          description
          latitude
          longitude
          id
          coverage
          state
        }
      }
      token
    }
  }
`,I=e.gql`
  mutation signUp(
    $clientId: String!
    $accessToken: String!
    $customerData: CustomerUpdateInput!
  ) {
    signUp(
      clientId: $clientId
      accessToken: $accessToken
      customerData: $customerData
    ) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        phoneNumberValidated
        customData
      }
      token
    }
  }
`,y=e.gql`
  mutation signUpWithProxy(
    $clientId: String!
    $customerData: CustomerUpdateInput!
  ) {
    signUpWithProxy(clientId: $clientId, customerData: $customerData) {
      customer {
        id
        name
        phoneNumber
        email
        terms
        notifications
        documentId
        uid
        customData
      }
      token
    }
  }
`,g=e.gql`
  mutation updateCustomerDocumentId(
    $customerId: ID!
    $documentId: String!
    $documentType: String
  ) {
    updateCustomerDocumentId(
      customerId: $customerId
      documentId: $documentId
      documentType: $documentType
    ) {
      id
      name
      documentId
    }
  }
`,$=e.gql`
  mutation Verify2FA($verify2FAInput: Verify2FAInput!) {
    verify2FA(verify2FAInput: $verify2FAInput) {
      success
    }
  }
`,P=e.gql`
  query CanRetryOrderPayment($jobNumber: String!) {
    canRetryOrderPayment(jobNumber: $jobNumber) {
      canRetry
      cartId
      paymentStatus
      operationalModel
      store {
        id
        dynamicParams
      }
    }
  }
`,h=e.gql`
  query CustomerLoggedIn {
    customerLoggedIn {
      id
      name
      phoneNumber
      email
      terms
      notifications
      documentId
      uid
      phoneNumberValidated
      customData
      addresses {
        address {
          structure
          other
        }
        addressTwo
        city
        description
        latitude
        id
        longitude
        coverage
        state
      }
      shoppingCartVersion
    }
  }
`,C=e.gql`
  query CustomerLoyaltyDetails {
    customerLoyaltyDetails {
      qrCodeId
      points
      redemptionEquivalence {
        conversionRate
        conversionValue
      }
    }
  }
`,q=e.gql`
  query CustomerLoyaltyPointsHistory(
    $customerLoyaltyPointsHistoryInput: CustomerLoyaltyPointsHistoryInput
  ) {
    customerLoyaltyPointsHistory(
      customerLoyaltyPointsHistoryInput: $customerLoyaltyPointsHistoryInput
    ) {
      currentPage
      nextPage
      items {
        date
        details
        points
        type
      }
    }
  }
`,x=e.gql`
  query CustomerLoyaltyPointsSummary(
    $customerLoyaltyPointsSummaryInput: CustomerLoyaltyPointsSummaryInput
  ) {
    customerLoyaltyPointsSummary(
      customerLoyaltyPointsSummaryInput: $customerLoyaltyPointsSummaryInput
    ) {
      currentPage
      nextPage
      items {
        description
        expirationDate
        points
      }
    }
  }
`,S=e.gql`
  query getAuthProviderURL($clientId: String!, $operation: String!) {
    getAuthProviderURL(clientId: $clientId, operation: $operation)
  }
`,b=e.gql`
  query GetCountry($name: String!) {
    getCountry(name: $name) {
      currency
    }
  }
`,v=e.gql`
  query GetEcommerceCartPaymentMethods($cartId: ID!) {
    getEcommerceCartPaymentMethods(cartId: $cartId) {
      type
      names
      paymentConfigurationId
      groupBy
    }
  }
`,D=e.gql`
  query($infoPaymentMethod: InfoPaymentMethod) {
    getInstallmentsPaymentMethods(infoPaymentMethod: $infoPaymentMethod) {
      cardExternalId
      installments {
        term
        interval
        intervalDuration
        currencyCode
        periodicPayment
      }
    }
  }
`,A=e.gql`
  mutation ValidateEcommerceCart($cartId: ID!) {
    validateEcommerceCart(cartId: $cartId) {
      loyalty {
        availablePoints {
          points
          conversionRate
          conversionValue
        }
        redeemable {
          points
          conversionRate
          conversionValue
        }
        selectedRedemption {
          points
          conversionRate
          conversionValue
        }
      }
    }
  }
`,N=e.gql`
  query getOnlinePaymentMethodsByCustomer {
    getOnlinePaymentMethodsByCustomer {
      creditCards {
        cardExternalId
        cardMask
        cardBrand
      }
    }
  }
`,f=e.gql`
  query GetPasswordResetValidation(
    $passwordResetValidationInput: PasswordResetValidationInput!
  ) {
    getPasswordResetValidation(
      passwordResetValidationInput: $passwordResetValidationInput
    ) {
      forcePasswordReset
    }
  }
`,T=e.gql`
  query IsPhoneNumberValid($isPhoneNumberValidInput: IsPhoneNumberValidInput!) {
    isPhoneNumberValid(isPhoneNumberValidInput: $isPhoneNumberValidInput) {
      isValid
    }
  }
`,V=e.gql`
  query userInWhiteList($email: String!) {
    userInWhiteList(email: $email)
  }
`,L=e.gql`
  mutation UpdateEcommerceCart($updateCartInput: UpdateEcommerceCartInput!) {
  updateEcommerceCart(updateCartInput: $updateCartInput) {
    validationIssues {
      reason
      productId
      type
    }
    paymentConfigurationId
    id
  }
}
`,k=e.gql`
  mutation RetryPurchaseEcommerceCart($purchaseCartInput: PurchaseCartInput!) {
    retryPurchaseEcommerceCart(purchaseCartInput: $purchaseCartInput) {
      id
      status
      jobId
      jobNumber
      operationalModel
      lobbyScreenToken
      purchaseDetails {
        id
        jobId
        jobNumber
      }
    }
  }
`,M=e.gql`
  query GetAddresses($getAddressesInput: GetAddressesInput!) {
    getAddresses(getAddressesInput: $getAddressesInput) {
      id
      description
      address {
        structure
        other
      }
      addressTwo
      available
      latitude
      longitude
      city
      state
      zipCode
      removed
      customerId
      distanceToStore
    }
  }
`,w=e.gql`
  query GetStoresNearbyByCoords(
    $clientId: String!
    $operationalModel: OperationModel!
    $coordinates: Coords!
  ) {
    getStoresNearbyByCoords(
      clientId: $clientId
      operationalModel: $operationalModel
      coordinates: $coordinates
    ) {
      id
      name
      code
      phone
      state
      cities {
        name
      }
      address
      country
      dynamicParams
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
      usedIfNotCoverage
    }
  }
`,R=e.gql`
  mutation Mutation($upsertAddressInput: UpsertAddressInput!) {
    upsertAddress(upsertAddressInput: $upsertAddressInput) {
      id
      description
      address {
        structure
        other
      }
      addressTwo
      available
      latitude
      longitude
      city
      state
      zipCode
      removed
      customerId
      distanceToStore
    }
  }
`;exports.A=y,exports.B=g,exports.C=V,exports.D=$,exports.E=L,exports.F=k,exports.G=M,exports.H=w,exports.I=R,exports.a=h,exports.b=C,exports.c=o,exports.d=q,exports.e=x,exports.f=r,exports.g=P,exports.h=s,exports.i=S,exports.j=b,exports.k=v,exports.l=D,exports.m=A,exports.n=N,exports.o=t,exports.p=T,exports.q=f,exports.r=i,exports.s=d,exports.t=u,exports.u=c,exports.v=m,exports.w=l,exports.x=a,exports.y=p,exports.z=I;